/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useAITranslatorSettingsLocal } from "./use-ai-translator-settings-local"
import { defaultSettings } from "../constants/translator-defaults"

export function useTranslationInstructions() {
  const { settings, updateSettings } = useAITranslatorSettingsLocal()

  const translationInstructions =
    settings.translationInstructions ?? defaultSettings.translationInstructions

  function handleChangeInstructions(e: React.ChangeEvent<HTMLInputElement>) {
    const newInstructions = e.target.value
    updateSettings({ translationInstructions: newInstructions })
  }

  return { handleChangeInstructions, translationInstructions }
}
